var version = {
    "name":      "dativery",
    "buildDateCode": "20261007-133205",
    "buildDate": "Wed Oct 07 2026 13:32:05 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261007-133205",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;